module.exports = __webpack_public_path__ + "static/img/aqzs45.53f101ff.jpg";